import React, { Component } from "react";
import { Bar } from "react-chartjs-2";
import styles from "./Analytics.scss";
import classnames from "classnames";

class SurveyResults extends Component {
	constructor(props) {
		super(props);
		this.state = {
			labels: [],
			data: [],
			data_info: [
				"Transit",
				"Amenities",
				"Services",
				"Home",
				"Backyard",
				"Home Ownership",
				"Salary Details"
			],
			active: "Transit"
		};
	}
	componentDidMount() {
		this.setChart(this.state.active);
	}

	// componentDidUpdate(prevProps) {
	// 	if (prevProps !== this.props) {
	// 		this.setChart("transit");
	// 	}
	// }

	setChart = label => {
		let labels = [];
		let data = [];
		let index = label.replace(/\s/g, '');
		for (var key in this.props[index].details) {
			labels.push(key);
			data.push(this.props[index].details[key]);
		}

		this.setState({
			labels,
			data,
			active: label
		});
	};

	render() {
		const data = {
			labels: this.state.labels,
			datasets: [
				{
					label: this.state.active,
					backgroundColor: "rgba(255,99,132,0.2)",
					borderColor: "rgba(255,99,132,1)",
					borderWidth: 1,
					hoverBackgroundColor: "rgba(255,99,132,0.4)",
					hoverBorderColor: "rgba(255,99,132,1)",
					data: this.state.data
				}
			]
		};

		return (
			<div className={classnames(styles.surveyresults)}>
				<div className="btn-group-vertical" role="group">
					{this.state.data_info.map((label, i) => (
						<button
							className={classnames(
								"btn btn-outline-secondary btn-sm",
								this.state.active === label ? "active" : ""
							)}
							onClick={() => this.setChart(label)}
						>
							{label}
						</button>
					))}
				</div>
				<div className={styles.surveychart}>
					<Bar
						data={data}
						options={{
							legend: {
								labels: {
									fontColor: "white",
								}
							},
							maintainAspectRatio: false,
							scales: {
								yAxes: [
									{
										ticks: {
											fontColor: "white",
											beginAtZero: true
										}
									}
								],
								xAxes: [
									{
										ticks: {
											fontColor: "white",
										}
									}
								]
							}
						}}
					/>
				</div>
			</div>
		);
	}
}

export default SurveyResults;



// WEBPACK FOOTER //
// ./src/components/pages/Analytics/SurveyResults.js